import Form from "views/Form";
import className from "classnames";
import { toast } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { parseError } from "utils/helpers";
import { formConfig } from "pages/CallCenter/CallCenterAgents/CreateCenterAgent/formConfig";
import { useEffect, useLayoutEffect, useState } from "react";
import { setNavbarTitle } from "features/navbar/navbarSlice";
import { searchHandler } from "models/search";
import { selectAllResults } from "features/search/searchSlice";
import FormElement from "components/Form/FormElement/FormElement";
import FormDropdown from "components/Form/FormDropdown/FormDropdown";
import { createSearchParams, useNavigate } from "react-router-dom";
import { dropdownItemSelector } from "models/form";
import cardStyles from "styles/modules/Card.module.scss";
import formStyles from "components/Form/Form.module.scss";
import utilityStyles from "styles/modules/Utility.module.scss";
import { useCreateCallCenterAgentsMutation } from "features/call_center/callCenterApiSlice";

const form = new Form(formConfig);

const CreateCenterAgent = () => {
  const [activeInput, setActiveInput] = useState("");

  const [formElements, setFormElements] = useState([]);
  const [formValidity, setFormValidity] = useState(false);

  const searchResults = useSelector(selectAllResults);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [createAgent, { isLoading }] = useCreateCallCenterAgentsMutation();

  useEffect(() => {
    dispatch(setNavbarTitle("New Call Center Agent"));
  }, [dispatch]);

  useLayoutEffect(() => {
    form.createFormElements();
    setFormElements(form.formElements);
  }, []);

  useEffect(() => {
    return () => {
      if (process.env.NODE_ENV === "production") {
        form.clear(); // will run once in production
        form.setConfig(formConfig);
      }
    };
  }, []);

  const submitFormHandler = async (e) => {
    e.preventDefault();

    const formData = {};

    if (formValidity) {
      for (const key in form.getFormConfig()) {
        const el = form.getFormConfig()[key];

        if (key === "user_id" || key === "domain_id") {
          formData[key] = el.elementConfig["data-id"] || el.elementConfig.value;
        } else if (el.elementConfig.type === "number") {
          formData[key] = form.parseFormValue(el.elementConfig.value, "number");
        } else {
          formData[key] = el.elementConfig.value;
        }
      }

      try {
        await createAgent(formData).unwrap();
        toast.success("Call Center Agent created successfully");
        navigate({
          pathname: "/call_center/agents",
          search: createSearchParams({ page: "1" }).toString(),
        });
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } catch (error) {
        const errorMessage = parseError(error);
        toast.error(errorMessage);
      }
    }
  };

  const dropdownItemClickHandler = (key, item) => {
    dropdownItemSelector(key, item, form);
    setFormElements(form.formElements);
    setActiveInput("");
  };

  const inputChangeHandler = (e) => {
    const updatedInput = form.inputChangeHandler(e);

    setActiveInput(e.target.id);

    if (updatedInput) {

      if (e.target.id === "user_id") {
        searchHandler("/users", e.target.value, dispatch);
      }
      if (e.target.id === "domain_id") {
        searchHandler("/domains", e.target.value, dispatch);
      }

      form.updateFormElement({ id: e.target.id, config: updatedInput });

      form.checkFormValidity();

      setFormElements(form.formElements);
      setFormValidity(form.isValid);
    }
  };

  return (
    <div
      className={`${utilityStyles.flexColumn} ${utilityStyles.itemsCenter} ${utilityStyles.justifyCenter}`}
    >
      <div
        className={className({
          [cardStyles.menu]: true,
          [utilityStyles.wFull]: true,
        })}
      >
        <h3>Fill in details for the new Agent</h3>
      </div>
      <div className={formStyles.wrapper}>
        <form className={formStyles.container} onSubmit={submitFormHandler}>
          {formElements.map((el, idx) => {
            const { title, elementType, elementConfig, ...config } = el.config;

            return (
              <div key={`el-group-${idx + 1}`} className={formStyles.group}>
                <FormElement
                  {...config}
                  title={title}
                  type={elementType}
                  id={elementConfig.id}
                  config={{
                    ...elementConfig,
                    onChange: inputChangeHandler,
                  }}
                />
                <FormDropdown
                  items={searchResults}
                  itemClickHandler={(item) =>
                    dropdownItemClickHandler(elementConfig.id, item)
                  }
                  visible={
                    activeInput === elementConfig.id && el.config.dropdown
                  }
                />
              </div>
            );
          })}
          <div className={formStyles.btn}>
            <button disabled={isLoading || !formValidity}>
              {isLoading ? "Creating Agent..." : "Create Agent"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateCenterAgent;
